import { prepareExternal } from './external-getter';

const EXTERNAL_GLOBAL_PROMISE_KEY = '__MEEGO_EXTERNALS_PROMISE__';

const createExternalGlobalPromise = (global: any, key: string) => {
  if (global[key]) {
    return;
  }
  Object.defineProperty(global, key, {
    enumerable: false,
    value: new Proxy(
      {},
      {
        get(_target, property: string) {
          return (async () => {
            if (global.__MEEGO_EXTERNALS__[property]) {
              return global.__MEEGO_EXTERNALS__[property];
            }
            await prepareExternal(property);
            return global.__MEEGO_EXTERNALS__[property];
          })();
        },
      },
    ),
  });
};

/**
 *  创建@meego-progressive external promise导入的全局单例
 *  __MEEGO_EXTERNALS_PROMISE__ 使用方在：jupiter.config.js remoteModuleExternals 生成对应的external 配置
 *  不要在业务代码中使用
 */
export const initExternalGlobalPromise = (getRoot = () => window) => {
  createExternalGlobalPromise(getRoot(), EXTERNAL_GLOBAL_PROMISE_KEY);
};
